module.exports = __webpack_public_path__ + "img/På-stengrunn_Bilde-av-Klevestrand-nederst.458dd9d5.jpg";